module.exports = __webpack_public_path__ + "3264413bb0846288b034cd80e23eaa1a.png";